// ** Initial State
const initialState = {
  allData: [],
  allPackageSubscribers: [],
  data: [],
  total: 1,
  params: {},
  currentUser: null,
  selectedUser: null,
  selectedBook: null,
  bookEdit: false,
  customPagination: null,
  currentSelectedPackageId: null,
  openModel: false,
  notifyId: null,
  allSelectedPackageUsersForNoti: [],
  allSelectedPackageUserNamesForNoti: [],
  singleNotiUser: null,
  token: JSON.parse(localStorage.getItem("accessToken")),
  found_results: '',
  entries_per_page: '',
  total_results: ''
}



const packageSubscriptions = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_PACKAGESUBSCRBERS':

      return { ...state, allPackageSubscribers: action.data, customPagination: action.customTotal, currentSelectedPackageId: action.currentSelectedPackageId, entries_per_page: action.entries_per_page, found_results: action?.found_results, total_results: action?.total_results }
    case 'NOTIFYID':
      return { ...state, notifyId: action.id, openModel: true, singleNotiUser: action.name }
    case 'SELECTED_PACKAGE_USER_FOR_NOTI':
      console.log(action.names);
      return { ...state, allSelectedPackageUsersForNoti: action.payload, allSelectedPackageUserNamesForNoti: action.names }
    case 'CLOSE_NOTI_MODEL':
      return { ...state, openModel: false, singleNotiUser: null }
    case 'SUBMIT_CLOSE_NOTI_MODEL_ADDON':
      return { ...state, openModel: false, allSelectedPackageUsersForNoti: [], allSelectedPackageUserNamesForNoti: [] }
    case 'OPEN_NOTI_MODEL':
      return { ...state, openModel: true }
    case 'GET_BOOK_DATA':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_USER':

      return { ...state, selectedUser: action.selectedUser }
    case 'ADD_USER':
      return { ...state, allData: action.data }
    case 'DELETE_BOOK':

      return { ...state, allPackageSubscribers: action.data }
    case 'EDITBOOK':
      return { ...state, selectedBook: action.data }
    case 'BOOK_PAGE_CHANGE':
      return { ...state, allPackageSubscribers: [] }
    // case 'START_LOADING':
    //   return {...state, loading: true}
    // case 'END_LOADING':
    //   return {...state, loading: false}
    default:
      return { ...state }
  }
}
export default packageSubscriptions
